import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/overlay';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import { Order } from '../../modules/patients/patient-details/medicines/patient-subscription-details/models/order.model';

@Injectable()
export class DialogService {

	constructor(private dialog: MatDialog) {
	}

	openDialog(component: ComponentType<any>, config?: MatDialogConfig): MatDialogRef<any> {
		return this.dialog.open(component, config);
	}

	openConfirmationDialog(
		message: string, 
		options?: { 
			leftButtonText?: string, 
			rightButtonText?: string, 
			hideLeftButton?: boolean, 
			hideRightButton?: boolean, 
			disableClose?: boolean, 
			invertButtonColors?: boolean, 
			hideIcon?: boolean, 
			hideDropdown?: boolean,
			isSubscriptionDelay?: boolean,
			subscriptionNextPaymentDate?: string,
			isRefundSubscriptionOrder?: boolean,
			order?: Order
		}
	): MatDialogRef<ConfirmationDialogComponent> {
		const config: MatDialogConfig = {
			role: 'alertdialog',
			panelClass: 'confirmation-dialog',
			disableClose: options?.disableClose
		};
		const dialogRef: MatDialogRef<ConfirmationDialogComponent> = this.openDialog(ConfirmationDialogComponent, config);
		dialogRef.componentInstance.message = message;
		dialogRef.componentInstance.onLeftButtonClick = () => dialogRef.close();
		dialogRef.componentInstance.onRightButtonClick = () => dialogRef.close();
		dialogRef.componentInstance.hideLeftButton = options?.hideLeftButton;
		dialogRef.componentInstance.hideRightButton = options?.hideRightButton;
		dialogRef.componentInstance.invertButtonColors = options?.invertButtonColors;
		dialogRef.componentInstance.hideIcon = options?.hideIcon;
		dialogRef.componentInstance.hideDropdown = options?.hideDropdown;
		dialogRef.componentInstance.isSubscriptionDelay = options?.isSubscriptionDelay;
		dialogRef.componentInstance.subscriptionNextPaymentDate = options?.subscriptionNextPaymentDate;
		dialogRef.componentInstance.isRefundSubscriptionOrder = options?.isRefundSubscriptionOrder;
		dialogRef.componentInstance.order = options?.order;
		if (options) {
			if (options.leftButtonText) {
				dialogRef.componentInstance.leftButtonText = options.leftButtonText;
			}
			if (options.rightButtonText) {
				dialogRef.componentInstance.rightButtonText = options.rightButtonText;
			}
		}
		return dialogRef;
	}

	closeAllDialogs(): void {
		this.dialog.closeAll();
	}

}
